// eslint-disable-next-line import/named
import { Tab } from './types';

export const getProfileTabLinks = (): Tab[] => [
  {
    label: 'Profile',
    to: '/dashboard/profile/me',
  },
  {
    label: 'Billing',
    to: '/dashboard/profile/billing/plan',
    additionalLinks: [
      '/dashboard/profile/billing/plan',
      '/dashboard/profile/billing/payment-method',
      '/dashboard/profile/billing/invoices',
      '/dashboard/profile/billing/credit-history',
    ],
  },
];
